export * from '../dependente/list/dependenteList.component';
export * from '../dependente/create/dependenteCreate.component';
export * from '../dependente/edit/dependenteEdit.component';
export * from '../dependente/detail/dependenteDetail.component';
export * from '../dependente/search/dependenteSearch.component';